import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { EmployeeService } from '../../../shared/services/employee.service';
import { DepartmentBus } from '../../../shared/models/DepartmentBus';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { CommonValues } from '../../../shared/static/CommonValues';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'departments-dialog',
    templateUrl: './departments-dialog.component.html',
    styleUrls: ['./departments-dialog.component.scss']
})
export class DepartmentsDialogComponent extends BaseAppMComponent<DepartmentBus, EmployeeService, null, null> {

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, public svc_data: EmployeeService, qry_rd: DQOIReferenceDataQuery, ) {
        super(globals, featureFlagService, qry_rd);

    }
    public editForm: UntypedFormGroup
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    saving: boolean = false;
    active: boolean = false;
    data: any;
    gridData: DepartmentBus[];
    action1: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    statusList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;

    }
    ok() {
        this.save();
    }

    save() {
        let user = this.globals.user;

        let busObj: DepartmentBus = new DepartmentBus();
        busObj.departmentName = this.editForm.controls["departmentName"].value;
        busObj.departmentId = this.editForm.controls["departmentId"].value;
        if (!busObj.departmentId) { busObj.departmentId = CommonValues.Guid_Empty }
        busObj.insertDt = new Date(Date.now());
        busObj.updateDt = new Date(Date.now());
        busObj.insertUserId = user.userid;
        busObj.updateUserId = user.userid;
        this.svc_data.saveDepartments(busObj).subscribe(data => {
            let result: ConfirmOutput = {
                action: this.action1, dialogResult: CPDialogResult.ok, data: {refresh:true}, code: this.code
            }
            this.confirmation.emit(result);
            this.hide();
        },
            err => { this.CallFailed(err) }
        );

    }

    CallFailed(err) {

        this.saveError(err)

    }
    cancel() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.createForm();
        this.active = true;
        this.svc_data.getDepartments().subscribe(data => {
            this.gridData = _.cloneDeep(data);
        });

    }
    public selectionChange(value: any): void {
        if (value) {

            this.editForm.patchValue({
                departmentName: value.departmentName,
              });

        }
        else {

            this.editForm.patchValue({
                departmentName: '',
            });
        }

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
                'departmentId': new UntypedFormControl(''),
            'departmentName': new UntypedFormControl('', Validators.required),

            });}
}

